export function appendError(errors, key, data) {
    if (typeof errors.data === 'undefined') {
        errors.data = {};
    }
    if (typeof errors.data[key] === 'undefined') {
        errors.data[key] = [];
    }
    const errorData = errors.data[key];
    if (typeof errorData !== 'undefined') {
        errorData.push(data);
    }
}
